import React from "react";
import { CreateJobForm } from "../../components";

export default function CreateJobPage() {
  return (
    <React.Fragment>
      <h2 className={"content-block"}>Create Job</h2>
      <CreateJobForm />
    </React.Fragment>
  );
}
